var map = {
	"./acsi.json": 1487,
	"./en-us.json": 638,
	"./id.json": 1488,
	"./ja.json": 1489,
	"./ko.json": 1490,
	"./vi.json": 1491,
	"./whitelists/whitelist_acsi.json": 1492,
	"./whitelists/whitelist_en-us.json": 1493,
	"./whitelists/whitelist_en.json": 1494,
	"./whitelists/whitelist_id.json": 1495,
	"./whitelists/whitelist_ja.json": 1496,
	"./whitelists/whitelist_ko.json": 1497,
	"./whitelists/whitelist_vi.json": 1498,
	"./whitelists/whitelist_zh-cn.json": 1499,
	"./whitelists/whitelist_zh-tw.json": 1500,
	"./zh-cn.json": 1501,
	"./zh-tw.json": 1502
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1486;